import React from 'react';
import { get } from 'lodash';
import { Segment, Tab } from 'semantic-ui-react';
import { parsePerformanceData } from './AccessPointPerformance';
import AccessPointPerformanceSector from './AccessPointPerformanceSector';
import { useFormContext } from 'react-hook-form';
import { iscnWave } from '../nd/configs/config-utils';

function TabbedAPPerformanceSummary({ data, disabled }) {
  const { warning, summary } = data;
  const { getValues } = useFormContext();
  const product = getValues('radios.0.equipment.product');
  const units = iscnWave(product) ? 'Gbps' : 'Mbps';
  const radioQty = getValues('radio_qty');
  const componentCarrierPerformance = radioQty >= 2 && !iscnWave(product);
  const { aggregate, radio_1, radio_2, radio_3 } = summary;
  const possibleRadioResults = [aggregate, radio_1, radio_2, radio_3];

  const panes = possibleRadioResults.map((summary) => {
    if (summary) {
      const perfData = parsePerformanceData(summary);
      return {
        menuItem: summary.label,
        render: () => (
          <Tab.Pane>
            <AccessPointPerformanceSector
              aggregates={perfData['aggregates']}
              data={perfData['data']}
              warning={warning.aggregate}
              throughputUnits={units}
              componentCarrierPerformance={componentCarrierPerformance}
              aggregateConnectedSMQty={summary.connected_sm_qty}
            ></AccessPointPerformanceSector>
          </Tab.Pane>
        ),
      };
    }
  });

  return (
    <Segment basic disabled={disabled}>
      <Tab panes={panes}></Tab>
    </Segment>
  );
}

export default TabbedAPPerformanceSummary;
